export const getBaseUrl = (): string => {
    // return 'https://api.wom-1.com';
    const domain = window.location.host.replaceAll("www.", "");
    if (
        domain.includes("localhost") ||
        domain.includes("radar-sample.com") ||
        domain.includes("sport-radar.watch") ||
        domain.includes("moongapgap.biz")
    ) {
        return `https://api.sport-radar.watch`;
        // return `https://api.sport-radar.watch`;
    } else {
        return `https://api.${domain}`;
    }
};

export const getSocketUrl = (): string => {
    const domain = window.location.host.replaceAll("www.", "");
    if (
        domain.includes("localhost") ||
        domain.includes("radar-sample.com") ||
        domain.includes("sport-radar.watch") ||
        domain.includes("moongapgap.biz")
    ) {
        return `wss://api.sport-radar.watch`;
    } else {
        return `wss://api.${domain}`;
    }
};
